/* eslint-disable */
export const RegistrationFormData = [
    {
      clientInfo: { name: "João Silva", email: "joao.silva@email.com", phone: "11987654321" },
      propertyInfo: { condition: "Novo", type: "Apartamento", bedrooms: 3, suites: 1, description: "Apartamento moderno com vista para o mar." },
      address: { street: "Rua das Palmeiras", number: "123", neighborhood: "Centro", zipCode: "01010-000", complement: "Apto 45B" }
    },
    {
      clientInfo: { name: "Maria Souza", email: "maria.souza@email.com", phone: "11876543210" },
      propertyInfo: { condition: "Usado", type: "Casa", bedrooms: 4, suites: 2, description: "Casa ampla com jardim e piscina." },
      address: { street: "Av. Brasil", number: "500", neighborhood: "Jardins", zipCode: "02020-000" }
    },
    {
      clientInfo: { name: "Carlos Mendes", email: "carlos.mendes@email.com" },
      propertyInfo: { condition: "Novo", type: "Cobertura", bedrooms: 2, suites: 2, description: "Cobertura luxuosa com área gourmet." },
      address: { street: "Rua XV de Novembro", number: "75", neighborhood: "Centro", zipCode: "03030-000", complement: "Cobertura" }
    },
    {
      clientInfo: { name: "Fernanda Lima", email: "fernanda.lima@email.com", phone: "11998877665" },
      propertyInfo: { condition: "Usado", type: "Apartamento", bedrooms: 2, suites: 1, description: "Apartamento aconchegante perto do metrô." },
      address: { street: "Rua das Flores", number: "90", neighborhood: "Vila Mariana", zipCode: "04040-000" }
    },
    {
      clientInfo: { name: "Roberto Nunes", email: "roberto.nunes@email.com" },
      propertyInfo: { condition: "Novo", type: "Casa", bedrooms: 5, suites: 3, description: "Casa moderna em condomínio fechado." },
      address: { street: "Av. Paulista", number: "1500", neighborhood: "Bela Vista", zipCode: "01310-000" }
    },
    {
      clientInfo: { name: "Ana Beatriz", email: "ana.beatriz@email.com", phone: "11997766554" },
      propertyInfo: { condition: "Usado", type: "Sobrado", bedrooms: 3, suites: 1, description: "Sobrado bem localizado e espaçoso." },
      address: { street: "Rua Augusta", number: "350", neighborhood: "Consolação", zipCode: "01415-000", complement: "Fundos" }
    },
    {
      clientInfo: { name: "Eduardo Campos", email: "eduardo.campos@email.com" },
      propertyInfo: { condition: "Novo", type: "Studio", bedrooms: 1, suites: 0, description: "Studio compacto e funcional no centro." },
      address: { street: "Rua Haddock Lobo", number: "120", neighborhood: "Cerqueira César", zipCode: "01414-000" }
    },
    {
      clientInfo: { name: "Gabriela Tavares", email: "gabriela.tavares@email.com", phone: "11993322110" },
      propertyInfo: { condition: "Usado", type: "Apartamento", bedrooms: 3, suites: 2, description: "Apartamento reformado com varanda gourmet." },
      address: { street: "Rua Vergueiro", number: "800", neighborhood: "Liberdade", zipCode: "01515-000" }
    },
    {
      clientInfo: { name: "Lucas Almeida", email: "lucas.almeida@email.com", phone: "11985553322" },
      propertyInfo: { condition: "Novo", type: "Loft", bedrooms: 1, suites: 1, description: "Loft sofisticado com decoração moderna." },
      address: { street: "Rua Oscar Freire", number: "250", neighborhood: "Jardins", zipCode: "01426-000" }
    },
    {
      clientInfo: { name: "Patrícia Santos", email: "patricia.santos@email.com" },
      propertyInfo: { condition: "Usado", type: "Casa", bedrooms: 4, suites: 2, description: "Casa espaçosa com quintal e churrasqueira." },
      address: { street: "Av. Ibirapuera", number: "700", neighborhood: "Moema", zipCode: "04521-000", complement: "Casa 2" }
    }
  ];